export default "/images/d1ac49399a462ac5b3e128dbd04eeb8f.png";